/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/54134918/layer/83648425
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import clone from 'ramda/src/clone';
import includes from 'ramda/src/includes';
import without from 'ramda/src/without';
import Button from '@components/@core/AnimatedButton';

// Import Bootstrap 5.3 Modal from main modals
import { Modal } from '@components/@modals';
import Icon from '@components/@core/Icon';
import AppActions from '~/actions/app';

class AdvancedSearch extends React.Component {
    state = {
        show: false,
        selectedOptions: this.props.selected,
        isSelectAll:
            this.props.selected.authors.length === 0 && this.props.selected.categories.length === 0 && this.props.selected.departments.length === 0 && this.props.selected.competencies.length === 0,
    };

    handleSelectItem = (key, item) => () => {
        const { selectedOptions } = this.state;
        if (!includes(item.id, selectedOptions[key])) {
            const temp = clone(selectedOptions);
            temp[key].push(item.id);
            this.setState({ selectedOptions: temp, isSelectAll: false });
        } else {
            let temp = clone(selectedOptions);
            temp[key] = without([item.id], temp[key]);
            if (temp.authors.length === 0 && temp.departments.length === 0 && temp.competencies.length === 0 && temp.categories.length === 0) {
                this.setState({
                    isSelectAll: true,
                    selectedOptions: { authors: [], departments: [], competencies: [], categories: [] },
                });
            } else {
                this.setState({ selectedOptions: temp, isSelectAll: false });
            }
        }
    };

    handleSelectAll = () => {
        this.setState({
            isSelectAll: true,
            selectedOptions: { authors: [], departments: [], competencies: [], categories: [] },
        });
    };

    handleApply = () => {
        this.props.setFilters(this.state.selectedOptions, this.props.mode === 'health plans' ? 'careers' : this.props.mode, this.props.published, this.props.tracking);
        this.setState({ show: false });
    };

    showModal = () => {
        const { selected } = this.props;
        this.setState({
            show: true,
            selectedOptions: selected,
            isSelectAll: selected.authors.length === 0 && selected.categories.length === 0 && selected.departments.length === 0 && selected.competencies.length === 0,
        });
    };

    render() {
        const { selectedOptions, isSelectAll, show } = this.state;
        const { className, authors, categories, competencies, departments } = this.props;

        return (
            <div className={className}>
                <span className="dsl-p14 cursor-pointer" onClick={this.showModal}>
                    Advanced Search
                </span>
                <Modal className="app-modal advanced-search" show={show} onHide={() => this.setState({ show: false })}>
                    <div className="modal-header">
                        <Icon name="fas fa-search me-2" color="white" size={14} />
                        <span className="dsl-w14">Advanced Search</span>
                    </div>
                    <div className="modal-body">
                        <Row className="mx-0 pb-0">
                            <Col xs={6} md={3}>
                                <div className={`option-item${isSelectAll ? ' active' : ''}`} onClick={this.handleSelectAll}>
                                    Show All
                                </div>
                            </Col>
                        </Row>
                        <Row className="mx-0 pt-1">
                            <Col xs={6} md={3} className="border-r">
                                <div className="option-label">Author</div>
                                {authors?.map((author) => (
                                    <div className={`option-item${includes(author.id, selectedOptions.authors) ? ' active' : ''}`} key={author.id} onClick={this.handleSelectItem('authors', author)}>
                                        {author.name}
                                    </div>
                                ))}
                            </Col>
                            <Col xs={6} md={3} className="border-r">
                                <div className="option-label">Department</div>
                                {departments?.map((department) => (
                                    <div
                                        className={`option-item${includes(department.id, selectedOptions.departments) ? ' active' : ''}`}
                                        key={department.id}
                                        onClick={this.handleSelectItem('departments', department)}
                                    >
                                        {department.name}
                                    </div>
                                ))}
                            </Col>
                            <Col xs={6} md={3} className="border-r">
                                <div className="option-label">Competency</div>
                                {competencies?.map((competency) => (
                                    <div
                                        className={`option-item${includes(competency.id, selectedOptions.competencies) ? ' active' : ''}`}
                                        key={competency.id}
                                        onClick={this.handleSelectItem('competencies', competency)}
                                    >
                                        {competency.name}
                                    </div>
                                ))}
                            </Col>
                            <Col xs={6} md={3}>
                                <div className="option-label">Category</div>
                                {categories?.map((category) => (
                                    <div
                                        className={`option-item${includes(category.id, selectedOptions.categories) ? ' active' : ''}`}
                                        key={category.id}
                                        onClick={this.handleSelectItem('categories', category)}
                                    >
                                        {category.name}
                                    </div>
                                ))}
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <Button name="APPLY" onClick={this.handleApply} />
                    </div>
                </Modal>
            </div>
        );
    }
}

AdvancedSearch.propTypes = {
    mode: PropTypes.oneOf([
        'tracks',
        'courses',
        'modules',
        'careers',
        'certifications',
        'badges',
        'power points',
        'words',
        'pdf',
        'envelopes',
        'habits',
        'habitslist',
        'habits schedules',
        'quotas',
        'scorecards',
        'esign',
        'packets',
        'daily',
        'monthly',
        'quarterly',
        'yearly',
        'health plans',
    ]),
    published: PropTypes.bool,
};

AdvancedSearch.defaultProps = {
    mode: 'tracks',
    published: false,
};

const mapStateToProps = (state) => ({
    type: state.app.modalType,
    data: state.app.modalData,
    callback: state.app.modalCallBack,
    authors: state.app.authors,
    categories: state.app.categories,
    competencies: state.app.competencies,
    departments: state.app.departments,
    selected: state.app.selectedTags,
});

const mapDispatchToProps = (dispatch) => ({
    setFilters: (tags, target, published, tracking) => dispatch(AppActions.advancedsearchRequest(tags, target, published, tracking)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedSearch);
